/* Keep Electro's cart display in sync with Ego's asynchronous gift updates.
 * This only requests rendered sections; gift quantities and discounts remain
 * owned by the app. */
(() => {
  let timer;
  let revision = 0;
  let busy = false;
  const schedule = () => {
    revision += 1;
    clearTimeout(timer);
    timer = setTimeout(refresh, 400);
  };
  async function refresh() {
    if (busy) return;
    busy = true;
    const current = revision;
    try {
      const url = new URL(window.location.href);
      url.search = '';
      url.searchParams.set('sections', 'cart-drawer,header-cart-status,cart-notification-panel-product');
      const response = await fetch(url, { cache: 'no-store' });
      if (!response.ok) return;
      const sections = await response.json();
      if (current !== revision) return;
      const parser = new DOMParser();
      const replacements = [
        ['cart-drawer', '#cartDrawer .js-cart-drawer-wrapper', '.js-cart-drawer-wrapper'],
        ['header-cart-status', '#headerCartStatus', '.shopify-section'],
        ['cart-notification-panel-product', '.js-cart-notification-panel-item-count-content', '.js-cart-notification-panel-item-count']
      ];
      for (const [section, targetSelector, sourceSelector] of replacements) {
        const target = document.querySelector(targetSelector);
        if (!target || !sections[section]) continue;
        const source = parser.parseFromString(sections[section], 'text/html').querySelector(sourceSelector);
        if (!source) continue;
        target.innerHTML = source.innerHTML;
        if (section === 'cart-drawer') target.classList.toggle('is-empty', source.classList.contains('is-empty'));
      }
    } catch (error) {
      console.warn('Gift cart display could not refresh.', error);
    } finally {
      busy = false;
      if (current !== revision) timer = setTimeout(refresh, 100);
    }
  }
  ['ego:api:gift_added', 'ego:api:gift_removed', 'ego:api:discount_updated'].forEach(event => window.addEventListener(event, schedule));
  document.querySelector('ecx-cart-drwr')?.addEventListener('opened', schedule);
})();
